export default "__VITE_ASSET__D9DBjR6o__"